export const getEmailsApi = '/api/emails'
export const postEmailsApi = '/api/emails/send-emails'
export const patchEmailApi = '/api/emails/:id'
export const deleteEmailApi = '/api/emails/:id'